import { topliApi } from '@/shared/api/topli/TopliApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { unitListsByBuildingIdQueryKey, unitListsByPageQueryKey } from '@/entities/Unit'
import { currentBuildingByIdQueryKey } from '@/entities/Building'
import { PhotoOwner } from '@/entities/Photos'

export const deleteUnit = async (unitId: number) => {
  const response = await topliApi.unit.delete(unitId)
  return response
}

export const useDeleteUnitApi = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => deleteUnit(id),
    onSuccess: (_res, id) => {
      topliApi.photo.deleteAllPhotos({ id, owner_id: PhotoOwner.Unit })

      Promise.all([
        queryClient.invalidateQueries({
          queryKey: [unitListsByPageQueryKey],
          refetchType: 'active',
        }),
        queryClient.invalidateQueries({
          queryKey: [currentBuildingByIdQueryKey],
          refetchType: 'active',
        }),
        queryClient.invalidateQueries({
          queryKey: [unitListsByBuildingIdQueryKey],
          refetchType: 'active',
        }),
      ])
    },
  })
}
